'use strict'

export default (mockAxios) => {
  mockAxios.onPut(`/personal-settings/pin`).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/pvPinRepositoryMock.js